/**
 * The one file that names the Worker (ruling 23). webpack turns this into a
 * separate chunk holding the parser and both libraries. Jest cannot load a
 * module that uses import.meta, so every test mocks this file.
 */
export function startParseWorker() {
  return new Worker(new URL('./parse.worker.js', import.meta.url), { type: 'module' });
}
